module.exports = __webpack_public_path__ + "static/media/app6.ab7f428f.png";